import { Box, chakra, Flex, Text } from "@chakra-ui/react";

const EmailVerificationContainer = chakra(Box, {
  baseStyle: {
    minWidth: { base: "full", md: "400px", lg: "560px" },
    paddingTop: { base: "0px", md: "50px" },
  },
});

const StyledDescription = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    color: "primary.grayText",
    fontSize: "14px",
  },
});

const StyledInboxLink = chakra(Flex, {
  baseStyle: {
    display: "flex",
    py: "5px",
    gap: "10px",
    alignItems: "center",
    justifyContent: "flex-start",
  },
});

const StyledSignupHeading = chakra(Box, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "24px", md: "32px" },
  },
});
const StyledSignupSubHeading = chakra(Box, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "24px", md: "32px" },
    color: "purple.500",
  },
});

const StyledSignupDescription = chakra(Box, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "12px", md: "16px" },
    mt: "6px",
    color: "primary.grayText",
  },
});

export {
  EmailVerificationContainer,
  StyledInboxLink,
  StyledDescription,
  StyledSignupHeading,
  StyledSignupSubHeading,
  StyledSignupDescription,
};
